import React, { useState } from "react";
import { IdCard as IdIcon, ClipboardList, GraduationCap, TrendingUp, CalendarCheck, Target, MessageSquareText } from "lucide-react";
import IdCard from "./IdCard";
import { useStudentData } from "../hooks";
import {
  AttendanceSection,
  EvaluationsSection,
  FeedbackSection,
  GoalsSection,
  GradesSection,
  ProgressSection,
} from "./StudentSections";

const TABS = [
  ["card", "Mi carnet", IdIcon],
  ["evaluations", "Evaluaciones", ClipboardList],
  ["grades", "Calificaciones", GraduationCap],
  ["progress", "Progreso", TrendingUp],
  ["attendance", "Asistencia", CalendarCheck],
  ["goals", "Objetivos", Target],
  ["feedback", "Devoluciones", MessageSquareText],
];

export default function StudentView({ student, ownerLabel = "Mi" }) {
  const [tab, setTab] = useState("card");
  const { assessments, goals, attendance, loaded } = useStudentData(student.id);
  const publicUrl = `${window.location.origin}/english-id/card/${student.publicToken}`;

  const body = {
    card: (
      <div className="flex flex-col items-center sm:items-start">
        <IdCard student={student} publicUrl={publicUrl} downloadable />
      </div>
    ),
    evaluations: <EvaluationsSection assessments={assessments} />,
    grades: <GradesSection assessments={assessments} />,
    progress: <ProgressSection assessments={assessments} goals={goals} attendance={attendance} />,
    attendance: <AttendanceSection attendance={attendance} />,
    goals: <GoalsSection goals={goals} />,
    feedback: <FeedbackSection assessments={assessments} />,
  }[tab];

  return (
    <div className="space-y-6" data-testid="eid-student-view">
      <div className="relative -mx-5">
      <div className="pointer-events-none absolute right-0 top-0 bottom-1 w-10 bg-gradient-to-l from-[#F6EFDF] to-transparent sm:hidden z-10" />
      <nav className="px-5 overflow-x-auto" aria-label="Secciones">
        <div className="flex gap-2 w-max pb-1">
          {TABS.map(([key, text, Icon]) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap px-3.5 py-2 rounded-full text-[12px] font-semibold border transition-colors ${
                tab === key
                  ? "bg-[#132C44] text-[#F6EFDF] border-[#132C44]"
                  : "bg-white/70 text-[#132C44] border-[#132C44]/15 hover:border-[#132C44]/40"
              }`}
              aria-current={tab === key ? "page" : undefined}
              data-testid={`eid-sv-tab-${key}`}
            >
              <Icon className="h-3.5 w-3.5" />
              {key === "card" ? `${ownerLabel} carnet` : text}
            </button>
          ))}
        </div>
      </nav>
      </div>
      <section className="animate-in fade-in duration-300">
        {loaded || tab === "card" ? body : <p className="text-[13px] text-[#132C44]/60">Cargando…</p>}
      </section>
    </div>
  );
}
